<mat-toolbar class="!flex !justify-between !items-center">
  <h2 mat-dialog-title class="!text-gray-900 !font-primary !text-3xl !font-semibold !leading-[140%]">
    {{ 'Exit confirmation' | translate }}
  </h2>
</mat-toolbar>
<mat-dialog-content class="!pt-2">
  {{
    'You have unsaved changes. If you leave now, those changes will be lost. Do you want to leave without saving?'
      | translate
  }}
</mat-dialog-content>
<mat-dialog-actions class="!grid !grid-cols-2 !gap-4">
  <button mat-flat-button mat-dialog-close class="cancel-button w-full" [mat-dialog-close]="false">
    {{ 'Cancel' | translate }}
  </button>
  <button mat-flat-button class="primary-button !ml-0 w-full" [mat-dialog-close]="true">
    {{ 'Leave' | translate }}
  </button>
</mat-dialog-actions>
